<script setup>
import ArtistTile from '@components/artist/artist-tile'

defineProps({
    artists: {
        type: Array,
        default: () => [],
    },
    extended: {
        type: Boolean,
        default: false,
    },
    hasTypeTitle: {
        type: Boolean,
        default: false,
    },
    error: {
        type: [Object, Boolean],
        default: false,
    },
})
</script>

<template>
    <div class="artist-block">
        <div class="inner">
            <ArtistTile
                v-for="artist in artists"
                :key="artist.id"
                :artist="artist"
                :extended="extended"
                :has-type-title="hasTypeTitle"
            />
        </div>
        <BaseEmptyList
            v-if="artists.length === 0 && error"
            :error="error"
        />
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.artist-block {
    max-width: none;
}

.inner {
    display: flex;
    flex-wrap: wrap;
    padding-right: 0;
    padding-bottom: $size-large-grid-padding;
    padding-left: 0;
}
</style>
